import React from 'react';
import Grid from '@mui/material/GridLegacy';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, FormControl, Select, MenuItem } from '@mui/material';
import { DIALOG_CONTENT_SX } from '../../../theme';

export default function BusinessSubmissionDetailsDialog({
  open,
  onClose,
  submission,
  onUpdateStatus,
  setSubmission,
}) {
  if (!submission) return null;
  const status = submission.status === 'pending' || submission.status === 'approved' || submission.status === 'rejected' ? "didn't_contact_yet" : (submission.status || "didn't_contact_yet");
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)' } }}
    >
      <DialogTitle sx={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontWeight: 700,
        py: 3,
        px: 4
      }}>
        Business Submission Details
      </DialogTitle>
      <DialogContent sx={DIALOG_CONTENT_SX}>
        <Box sx={{ pt: 1 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>Business/Place Name</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{submission.businessName || submission.placeName || 'N/A'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>Contact Name</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{submission.contactName || 'N/A'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>Email</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, wordBreak: 'break-word' }}>{submission.email || 'N/A'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>Phone</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{submission.phone || 'N/A'}</Typography>
              </Box>
            </Grid>
            {submission.category && (
              <Grid item xs={12} sm={6}>
                <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>Category</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>{submission.category}</Typography>
                </Box>
              </Grid>
            )}
            {submission.location && (
              <Grid item xs={12} sm={6}>
                <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>Location</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>{submission.location}</Typography>
                </Box>
              </Grid>
            )}
            {submission.description && (
              <Grid item xs={12}>
                <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>Description</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>{submission.description}</Typography>
                </Box>
              </Grid>
            )}
            {submission.additionalInfo && (
              <Grid item xs={12}>
                <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>Additional Info</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>{submission.additionalInfo}</Typography>
                </Box>
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>Status</Typography>
                <FormControl fullWidth size="small">
                  <Select
                    value={status}
                    onChange={(e) => {
                      onUpdateStatus(submission._id, e.target.value);
                      setSubmission({ ...submission, status: e.target.value });
                    }}
                    sx={{ borderRadius: 2, textTransform: 'none' }}
                  >
                    <MenuItem value="didn't_contact_yet">Didn't Contact Yet</MenuItem>
                    <MenuItem value="successfully_contacted">Successfully Contacted</MenuItem>
                    <MenuItem value="didn't_contact_successfully">Didn't Contact Successfully</MenuItem>
                    <MenuItem value="didn't_meet_criteria">Didn't Meet Criteria</MenuItem>
                    <MenuItem value="rejected_offer">Rejected Offer</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>Submitted</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{new Date(submission.submittedAt || submission.createdAt).toLocaleString()}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, bgcolor: 'rgba(0, 0, 0, 0.02)' }}>
        <Button onClick={onClose} sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 500, px: 3 }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
